import { useParams, useLocation } from 'react-router-dom';
import OrderTable from './OrderTable';

// Thin wrapper around the shared OrderTable, scoped to one customer via
// the :id route param. The customer's name is passed through router
// state from the "View Order History" link for a nicer heading — if the
// page is reloaded directly, it just falls back to showing no name.
const UserOrderHistory = () => {
    const { id } = useParams();
    const location = useLocation();
    const customerName = location.state?.customerName || null;

    return <OrderTable userId={id} customerName={customerName} />;
};

export default UserOrderHistory;